import { render, staticRenderFns } from "./InputAction.vue?vue&type=template&id=54c04950&scoped=true&lang=pug&"
import script from "./InputAction.vue?vue&type=script&lang=ts&"
export * from "./InputAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c04950",
  null
  
)

export default component.exports